import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-title flex flex-col sm:flex-row gap-3 items-start sm:items-center" }
const _hoisted_4 = { class: "relative sm:w-[265px]" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "trezo-card-subtitle mt-[15px] sm:mt-0" }
const _hoisted_7 = { class: "trezo-card-dropdown relative" }
const _hoisted_8 = { class: "inline-block relative ltr:pr-[17px] ltr:md:pr-[20px] rtl:pl-[17px] rtl:ml:pr-[20px]" }
const _hoisted_9 = {
  key: 0,
  class: "trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[5] dark:bg-dark dark:shadow-none"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "trezo-card-content -mx-[20px] md:-mx-[25px]" }
const _hoisted_12 = {
  key: 0,
  class: "text-center p-5"
}
const _hoisted_13 = { class: "mt-2" }
const _hoisted_14 = {
  key: 1,
  class: "text-center p-5"
}
const _hoisted_15 = {
  key: 2,
  class: "table-responsive overflow-x-auto"
}
const _hoisted_16 = { class: "w-full" }
const _hoisted_17 = { class: "text-black dark:text-white" }
const _hoisted_18 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_19 = { class: "form-check relative top-[2px]" }
const _hoisted_20 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_21 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_22 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_23 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_24 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_25 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_26 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_27 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_28 = { class: "text-black dark:text-white" }
const _hoisted_29 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_30 = { class: "form-check relative top-[2px]" }
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_33 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_34 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_35 = { class: "flex items-center" }
const _hoisted_36 = { class: "ltr:ml-[12px] rtl:mr-[12px]" }
const _hoisted_37 = { class: "block font-medium" }
const _hoisted_38 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_39 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_40 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_41 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_42 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_43 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_44 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_45 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_46 = { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }
const _hoisted_47 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_48 = { class: "flex items-center gap-[9px]" }
const _hoisted_49 = ["data-text", "onClick"]
const _hoisted_50 = ["data-text", "onClick"]
const _hoisted_51 = ["data-text", "onClick"]
const _hoisted_52 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_53 = { class: "bg-white dark:bg-[#0c1427] p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-2xl mx-4 z-10 relative max-h-[90vh] overflow-y-auto" }
const _hoisted_54 = { class: "flex justify-between items-center mb-4" }
const _hoisted_55 = { class: "text-lg font-medium text-black dark:text-white" }
const _hoisted_56 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_57 = {
  for: "first_name",
  class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
}
const _hoisted_58 = ["placeholder"]
const _hoisted_59 = {
  for: "last_name",
  class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
}
const _hoisted_60 = ["placeholder"]
const _hoisted_61 = {
  for: "email",
  class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
}
const _hoisted_62 = ["placeholder"]
const _hoisted_63 = {
  for: "phone",
  class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
}
const _hoisted_64 = ["placeholder"]
const _hoisted_65 = {
  for: "status",
  class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
}
const _hoisted_66 = { value: "Active" }
const _hoisted_67 = { value: "Inactive" }
const _hoisted_68 = { value: "Pending" }
const _hoisted_69 = {
  for: "received",
  class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
}
const _hoisted_70 = ["placeholder"]
const _hoisted_71 = { class: "sm:col-span-2" }
const _hoisted_72 = {
  for: "address",
  class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
}
const _hoisted_73 = ["placeholder"]
const _hoisted_74 = {
  for: "city",
  class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
}
const _hoisted_75 = ["placeholder"]
const _hoisted_76 = {
  for: "state",
  class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
}
const _hoisted_77 = ["placeholder"]
const _hoisted_78 = {
  for: "country",
  class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
}
const _hoisted_79 = ["placeholder"]
const _hoisted_80 = { class: "flex justify-end space-x-3 mt-6" }
const _hoisted_81 = ["disabled"]
const _hoisted_82 = {
  key: 0,
  class: "inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"
}
const _hoisted_83 = {
  key: 1,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_84 = { class: "bg-white dark:bg-[#0c1427] p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-md mx-4 z-10 relative" }
const _hoisted_85 = { class: "flex justify-between items-center mb-4" }
const _hoisted_86 = { class: "text-lg font-medium text-black dark:text-white" }
const _hoisted_87 = { class: "mb-6" }
const _hoisted_88 = { class: "text-gray-700 dark:text-gray-300" }
const _hoisted_89 = { class: "flex flex-col sm:flex-row sm:justify-end gap-2" }
const _hoisted_90 = ["disabled"]
const _hoisted_91 = {
  key: 2,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_92 = { class: "bg-white dark:bg-[#0c1427] p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-md mx-4 z-10 relative max-h-[90vh] overflow-y-auto" }
const _hoisted_93 = { class: "flex justify-between items-center mb-4" }
const _hoisted_94 = { class: "text-lg font-medium text-black dark:text-white" }
const _hoisted_95 = { class: "space-y-4" }
const _hoisted_96 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_97 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_98 = { class: "text-base text-black dark:text-white" }
const _hoisted_99 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_100 = { class: "text-base text-black dark:text-white break-words" }
const _hoisted_101 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_102 = { class: "text-base text-black dark:text-white" }
const _hoisted_103 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_104 = { class: "text-base" }
const _hoisted_105 = { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }
const _hoisted_106 = { class: "md:col-span-2" }
const _hoisted_107 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_108 = { class: "text-base text-black dark:text-white" }
const _hoisted_109 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_110 = { class: "text-base text-black dark:text-white" }
const _hoisted_111 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_112 = { class: "text-base text-black dark:text-white" }
const _hoisted_113 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_114 = { class: "text-base text-black dark:text-white" }
const _hoisted_115 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_116 = { class: "text-base text-black dark:text-white" }
const _hoisted_117 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_118 = { class: "text-base text-black dark:text-white" }
const _hoisted_119 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_120 = { class: "text-base text-black dark:text-white" }
const _hoisted_121 = { class: "flex justify-end mt-6" }
const _hoisted_122 = {
  key: 3,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_123 = { class: "bg-white dark:bg-[#0c1427] p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-md mx-4 z-10 relative max-h-[90vh] overflow-y-auto" }
const _hoisted_124 = { class: "flex justify-between items-center mb-4" }
const _hoisted_125 = { class: "text-lg font-medium text-black dark:text-white" }
const _hoisted_126 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" }
const _hoisted_127 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_128 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_129 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_130 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_131 = { class: "md:col-span-2" }
const _hoisted_132 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_133 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_134 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_135 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_136 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_137 = { class: "relative" }
const _hoisted_138 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_139 = ["value"]
const _hoisted_140 = { class: "flex flex-col sm:flex-row sm:justify-end gap-2" }
const _hoisted_141 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", _hoisted_4, [
            _cache[41] || (_cache[41] = _createElementVNode("label", { class: "leading-none absolute ltr:left-[13px] rtl:right-[13px] text-black dark:text-white mt-px top-1/2 -translate-y-1/2" }, [
              _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, " search ")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
              placeholder: _ctx.directT('crm.customers.searchCustomer'),
              class: "bg-gray-50 border border-gray-50 h-[36px] text-xs rounded-md w-full block text-black pt-[11px] pb-[12px] ltr:pl-[38px] rtl:pr-[38px] ltr:pr-[13px] ltr:md:pr-[16px] rtl:pl-[13px] rtl:md:pl-[16px] placeholder:text-gray-500 outline-0 dark:bg-[#15203c] dark:text-white dark:border-[#15203c] dark:placeholder:text-gray-400"
            }, null, 8, _hoisted_5), [
              [_vModelText, _ctx.searchQuery]
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addNewCustomer && _ctx.addNewCustomer(...args))),
            class: "bg-primary-500 hover:bg-primary-600 text-white rounded-md px-4 py-2 text-sm font-medium transition-all flex items-center"
          }, [
            _cache[42] || (_cache[42] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] mr-1" }, "add", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.customers.addCustomer')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass({
              'trezo-card-dropdown-btn inline-block transition-all hover:text-primary-500': true,
              active: _ctx.isActive,
            }),
              id: "dropdownToggle",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["stop"]))
            }, [
              _createElementVNode("span", _hoisted_8, [
                _createTextVNode(_toDisplayString(_ctx.statusFilter === 'All' ? _ctx.directT('crm.customers.all') : 
                 _ctx.statusFilter === 'New' ? _ctx.directT('crm.customers.new') : 
                 _ctx.statusFilter === 'Active' ? _ctx.directT('crm.customers.active') : 
                 _ctx.statusFilter === 'Inactive' ? _ctx.directT('crm.customers.inactive') : _ctx.statusFilter) + " ", 1),
                _cache[43] || (_cache[43] = _createElementVNode("i", { class: "ri-arrow-down-s-line text-lg absolute ltr:-right-[3px] rtl:-left-[3px] top-1/2 -translate-y-1/2" }, null, -1))
              ])
            ], 2),
            (_ctx.isActive)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusOptions, (status) => {
                    return (_openBlock(), _createElementBlock("li", { key: status }, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => (_ctx.setStatusFilter(status)),
                        class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
                      }, _toDisplayString(status === 'All' ? _ctx.directT('crm.customers.all') : 
                   status === 'New' ? _ctx.directT('crm.customers.new') : 
                   status === 'Active' ? _ctx.directT('crm.customers.active') : 
                   status === 'Inactive' ? _ctx.directT('crm.customers.inactive') : status), 9, _hoisted_10)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _cache[44] || (_cache[44] = _createElementVNode("div", { class: "spinner" }, null, -1)),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.directT('crm.customers.loading')), 1)
            ]))
          : (_ctx.clients.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("p", null, _toDisplayString(_ctx.directT('crm.customers.noCustomersFound')), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("table", _hoisted_16, [
                  _createElementVNode("thead", _hoisted_17, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            class: "cursor-pointer",
                            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.selectAllClients && _ctx.selectAllClients(...args))),
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectAll) = $event))
                          }, null, 544), [
                            [_vModelCheckbox, _ctx.selectAll]
                          ])
                        ])
                      ]),
                      _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.directT('crm.customers.id')), 1),
                      _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.directT('crm.customers.customer')), 1),
                      _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.directT('crm.customers.email')), 1),
                      _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.directT('crm.customers.phone')), 1),
                      _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.directT('crm.customers.source')), 1),
                      _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.directT('crm.customers.receivedAmount')), 1),
                      _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.directT('crm.customers.status')), 1),
                      _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.directT('crm.customers.action')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_28, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredClients, (client) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: client.id
                      }, [
                        _createElementVNode("td", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              class: "cursor-pointer",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedClients) = $event)),
                              value: client.id
                            }, null, 8, _hoisted_31), [
                              [_vModelCheckbox, _ctx.selectedClients]
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_32, [
                          _createElementVNode("span", _hoisted_33, _toDisplayString(client.id.substring(0, 8)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("span", _hoisted_37, _toDisplayString(client.first_name) + " " + _toDisplayString(client.last_name), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_38, _toDisplayString(client.email), 1),
                        _createElementVNode("td", _hoisted_39, [
                          _createElementVNode("span", _hoisted_40, _toDisplayString(client.phone), 1)
                        ]),
                        _createElementVNode("td", _hoisted_41, [
                          _createElementVNode("span", _hoisted_42, _toDisplayString(client.shopify_id ? 'Shopify' : client.woocommerce_id ? 'WooCommerce' : 'Manual'), 1)
                        ]),
                        _createElementVNode("td", _hoisted_43, [
                          _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.formatCurrency(client.received)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_45, [
                          _createElementVNode("span", _hoisted_46, _toDisplayString(client.status), 1)
                        ]),
                        _createElementVNode("td", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "text-primary-500 leading-none custom-tooltip",
                              id: "customTooltip",
                              "data-text": _ctx.directT('crm.customers.view'),
                              onClick: ($event: any) => (_ctx.viewCustomer(client))
                            }, _cache[45] || (_cache[45] = [
                              _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                            ]), 8, _hoisted_49),
                            _createElementVNode("button", {
                              type: "button",
                              class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip",
                              id: "customTooltip",
                              "data-text": _ctx.directT('crm.customers.edit'),
                              onClick: ($event: any) => (_ctx.editCustomer(client))
                            }, _cache[46] || (_cache[46] = [
                              _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                            ]), 8, _hoisted_50),
                            _createElementVNode("button", {
                              type: "button",
                              class: "text-danger-500 leading-none custom-tooltip",
                              id: "customTooltip",
                              "data-text": _ctx.directT('crm.customers.delete'),
                              onClick: ($event: any) => (_ctx.deleteClient(client.id))
                            }, _cache[47] || (_cache[47] = [
                              _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                            ]), 8, _hoisted_51)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])),
        _createVNode(_component_Pagination, {
          items: "10",
          total: "36",
          class: "px-[20px] md:px-[25px] pt-[12px] md:pt-[14px]"
        })
      ])
    ]),
    (_ctx.showAddModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black opacity-50",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("h3", _hoisted_55, _toDisplayString(_ctx.directT('crm.customers.addNewCustomer')), 1),
              _createElementVNode("button", {
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                class: "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 p-2 -m-2"
              }, _cache[48] || (_cache[48] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-xl" }, "close", -1)
              ]))
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveCustomer && _ctx.saveCustomer(...args)), ["prevent"])),
              class: "space-y-4"
            }, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_57, [
                    _createTextVNode(_toDisplayString(_ctx.directT('crm.customers.firstName')) + " ", 1),
                    _cache[49] || (_cache[49] = _createElementVNode("span", { class: "text-red-500" }, "*", -1))
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    id: "first_name",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newCustomer.first_name) = $event)),
                    type: "text",
                    required: "",
                    class: "w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-primary-500 dark:bg-[#132034] dark:border-[#132034] dark:text-white",
                    placeholder: _ctx.directT('crm.customers.enterFirstName')
                  }, null, 8, _hoisted_58), [
                    [_vModelText, _ctx.newCustomer.first_name]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_59, [
                    _createTextVNode(_toDisplayString(_ctx.directT('crm.customers.lastName')) + " ", 1),
                    _cache[50] || (_cache[50] = _createElementVNode("span", { class: "text-red-500" }, "*", -1))
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    id: "last_name",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newCustomer.last_name) = $event)),
                    type: "text",
                    required: "",
                    class: "w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-primary-500 dark:bg-[#132034] dark:border-[#132034] dark:text-white",
                    placeholder: _ctx.directT('crm.customers.enterLastName')
                  }, null, 8, _hoisted_60), [
                    [_vModelText, _ctx.newCustomer.last_name]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_61, [
                    _createTextVNode(_toDisplayString(_ctx.directT('crm.customers.email')) + " ", 1),
                    _cache[51] || (_cache[51] = _createElementVNode("span", { class: "text-red-500" }, "*", -1))
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    id: "email",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newCustomer.email) = $event)),
                    type: "email",
                    required: "",
                    class: "w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-primary-500 dark:bg-[#132034] dark:border-[#132034] dark:text-white",
                    placeholder: _ctx.directT('crm.customers.enterEmail')
                  }, null, 8, _hoisted_62), [
                    [_vModelText, _ctx.newCustomer.email]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.directT('crm.customers.phone')), 1),
                  _withDirectives(_createElementVNode("input", {
                    id: "phone",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newCustomer.phone) = $event)),
                    type: "tel",
                    class: "w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-primary-500 dark:bg-[#132034] dark:border-[#132034] dark:text-white",
                    placeholder: _ctx.directT('crm.customers.enterPhone')
                  }, null, 8, _hoisted_64), [
                    [_vModelText, _ctx.newCustomer.phone]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.directT('crm.customers.status')), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "status",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newCustomer.status) = $event)),
                    class: "w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-primary-500 dark:bg-[#132034] dark:border-[#132034] dark:text-white"
                  }, [
                    _createElementVNode("option", _hoisted_66, _toDisplayString(_ctx.directT('crm.customers.active')), 1),
                    _createElementVNode("option", _hoisted_67, _toDisplayString(_ctx.directT('crm.customers.inactive')), 1),
                    _createElementVNode("option", _hoisted_68, _toDisplayString(_ctx.directT('crm.customers.pending')), 1)
                  ], 512), [
                    [_vModelSelect, _ctx.newCustomer.status]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.directT('crm.customers.receivedAmount')), 1),
                  _withDirectives(_createElementVNode("input", {
                    id: "received",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newCustomer.received) = $event)),
                    type: "number",
                    min: "0",
                    step: "0.01",
                    class: "w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-primary-500 dark:bg-[#132034] dark:border-[#132034] dark:text-white",
                    placeholder: _ctx.directT('crm.customers.enterAmount')
                  }, null, 8, _hoisted_70), [
                    [_vModelText, _ctx.newCustomer.received]
                  ])
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.directT('crm.customers.address')), 1),
                  _withDirectives(_createElementVNode("input", {
                    id: "address",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newCustomer.address) = $event)),
                    type: "text",
                    class: "w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-primary-500 dark:bg-[#132034] dark:border-[#132034] dark:text-white",
                    placeholder: _ctx.directT('crm.customers.enterAddress')
                  }, null, 8, _hoisted_73), [
                    [_vModelText, _ctx.newCustomer.address]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.directT('crm.customers.city')), 1),
                  _withDirectives(_createElementVNode("input", {
                    id: "city",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newCustomer.city) = $event)),
                    type: "text",
                    class: "w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-primary-500 dark:bg-[#132034] dark:border-[#132034] dark:text-white",
                    placeholder: _ctx.directT('crm.customers.enterCity')
                  }, null, 8, _hoisted_75), [
                    [_vModelText, _ctx.newCustomer.city]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_76, _toDisplayString(_ctx.directT('crm.customers.state')), 1),
                  _withDirectives(_createElementVNode("input", {
                    id: "state",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newCustomer.state) = $event)),
                    type: "text",
                    class: "w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-primary-500 dark:bg-[#132034] dark:border-[#132034] dark:text-white",
                    placeholder: _ctx.directT('crm.customers.enterState')
                  }, null, 8, _hoisted_77), [
                    [_vModelText, _ctx.newCustomer.state]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.directT('crm.customers.country')), 1),
                  _withDirectives(_createElementVNode("input", {
                    id: "country",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newCustomer.country) = $event)),
                    type: "text",
                    class: "w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-primary-500 dark:bg-[#132034] dark:border-[#132034] dark:text-white",
                    placeholder: _ctx.directT('crm.customers.enterCountry')
                  }, null, 8, _hoisted_79), [
                    [_vModelText, _ctx.newCustomer.country]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                  class: "px-4 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-md transition-all dark:bg-[#172036] dark:text-gray-200 dark:hover:bg-[#1e2746]"
                }, _toDisplayString(_ctx.directT('crm.customers.cancel')), 1),
                _createElementVNode("button", {
                  type: "submit",
                  disabled: _ctx.loading,
                  class: "px-4 py-2.5 bg-primary-500 hover:bg-primary-600 text-white rounded-md transition-all flex items-center justify-center min-w-[100px]"
                }, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_82))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.loading ? _ctx.directT('crm.customers.saving') : _ctx.directT('crm.customers.save')), 1)
                ], 8, _hoisted_81)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black opacity-50",
            onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args)))
          }),
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("h3", _hoisted_86, _toDisplayString(_ctx.directT('crm.customers.confirmDeletion')), 1),
              _createElementVNode("button", {
                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args))),
                class: "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 p-2 -m-2"
              }, _cache[52] || (_cache[52] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-xl" }, "close", -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_87, [
              _createElementVNode("p", _hoisted_88, _toDisplayString(_ctx.directT('crm.customers.deleteConfirmation')), 1)
            ]),
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args))),
                class: "w-full sm:w-auto px-4 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-md transition-all dark:bg-[#172036] dark:text-gray-200 dark:hover:bg-[#1e2746] order-2 sm:order-1"
              }, _toDisplayString(_ctx.directT('crm.customers.cancel')), 1),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args))),
                class: "w-full sm:w-auto px-4 py-2.5 bg-danger-500 hover:bg-danger-600 text-white rounded-md transition-all order-1 sm:order-2 mb-2 sm:mb-0",
                disabled: _ctx.deleting
              }, _toDisplayString(_ctx.deleting ? _ctx.directT('crm.customers.deleting') : _ctx.directT('crm.customers.deleteCustomer')), 9, _hoisted_90)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showViewModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black opacity-50",
            onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.closeViewModal && _ctx.closeViewModal(...args)))
          }),
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("h3", _hoisted_94, _toDisplayString(_ctx.directT('crm.customers.customerDetails')), 1),
              _createElementVNode("button", {
                onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.closeViewModal && _ctx.closeViewModal(...args))),
                class: "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 p-2 -m-2"
              }, _cache[53] || (_cache[53] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-xl" }, "close", -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_97, _toDisplayString(_ctx.directT('crm.customers.fullName')), 1),
                  _createElementVNode("p", _hoisted_98, _toDisplayString(_ctx.selectedCustomer?.first_name) + " " + _toDisplayString(_ctx.selectedCustomer?.last_name), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_99, _toDisplayString(_ctx.directT('crm.customers.email')), 1),
                  _createElementVNode("p", _hoisted_100, _toDisplayString(_ctx.selectedCustomer?.email || 'N/A'), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_101, _toDisplayString(_ctx.directT('crm.customers.phone')), 1),
                  _createElementVNode("p", _hoisted_102, _toDisplayString(_ctx.selectedCustomer?.phone || 'N/A'), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_103, _toDisplayString(_ctx.directT('crm.customers.status')), 1),
                  _createElementVNode("p", _hoisted_104, [
                    _createElementVNode("span", _hoisted_105, _toDisplayString(_ctx.selectedCustomer?.status), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_106, [
                  _createElementVNode("p", _hoisted_107, _toDisplayString(_ctx.directT('crm.customers.address')), 1),
                  _createElementVNode("p", _hoisted_108, _toDisplayString(_ctx.selectedCustomer?.address || 'N/A'), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_109, _toDisplayString(_ctx.directT('crm.customers.city')), 1),
                  _createElementVNode("p", _hoisted_110, _toDisplayString(_ctx.selectedCustomer?.city || 'N/A'), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_111, _toDisplayString(_ctx.directT('crm.customers.state')), 1),
                  _createElementVNode("p", _hoisted_112, _toDisplayString(_ctx.selectedCustomer?.state || 'N/A'), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_113, _toDisplayString(_ctx.directT('crm.customers.country')), 1),
                  _createElementVNode("p", _hoisted_114, _toDisplayString(_ctx.selectedCustomer?.country || 'N/A'), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_115, _toDisplayString(_ctx.directT('crm.customers.receivedAmount')), 1),
                  _createElementVNode("p", _hoisted_116, _toDisplayString(_ctx.formatCurrency(_ctx.selectedCustomer?.received)), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_117, _toDisplayString(_ctx.directT('crm.customers.source')), 1),
                  _createElementVNode("p", _hoisted_118, _toDisplayString(_ctx.selectedCustomer?.shopify_id ? _ctx.directT('crm.customers.shopify') : 
                 _ctx.selectedCustomer?.woocommerce_id ? _ctx.directT('crm.customers.wooCommerce') : 
                 _ctx.directT('crm.customers.manual')), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_119, _toDisplayString(_ctx.directT('crm.customers.id')), 1),
                  _createElementVNode("p", _hoisted_120, _toDisplayString(_ctx.selectedCustomer?.id || 'N/A'), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_121, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.closeViewModal && _ctx.closeViewModal(...args))),
                class: "px-4 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-md transition-all dark:bg-[#172036] dark:text-gray-200 dark:hover:bg-[#1e2746]"
              }, _toDisplayString(_ctx.directT('crm.customers.close')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showEditModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black opacity-50",
            onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
          }),
          _createElementVNode("div", _hoisted_123, [
            _createElementVNode("div", _hoisted_124, [
              _createElementVNode("h3", _hoisted_125, _toDisplayString(_ctx.directT('crm.customers.editCustomer')), 1),
              _createElementVNode("button", {
                onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args))),
                class: "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 p-2 -m-2"
              }, _cache[54] || (_cache[54] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-xl" }, "close", -1)
              ]))
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[40] || (_cache[40] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveEdit && _ctx.saveEdit(...args)), ["prevent"])),
              class: "pb-1"
            }, [
              _createElementVNode("div", _hoisted_126, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_127, _toDisplayString(_ctx.directT('crm.customers.firstName')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.editingCustomer.first_name) = $event)),
                    required: "",
                    class: "bg-gray-50 border border-gray-200 rounded-md w-full px-3 py-2.5 text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]"
                  }, null, 512), [
                    [_vModelText, _ctx.editingCustomer.first_name]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_128, _toDisplayString(_ctx.directT('crm.customers.lastName')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.editingCustomer.last_name) = $event)),
                    required: "",
                    class: "bg-gray-50 border border-gray-200 rounded-md w-full px-3 py-2.5 text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]"
                  }, null, 512), [
                    [_vModelText, _ctx.editingCustomer.last_name]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_129, _toDisplayString(_ctx.directT('crm.customers.email')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.editingCustomer.email) = $event)),
                    required: "",
                    class: "bg-gray-50 border border-gray-200 rounded-md w-full px-3 py-2.5 text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]"
                  }, null, 512), [
                    [_vModelText, _ctx.editingCustomer.email]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_130, _toDisplayString(_ctx.directT('crm.customers.phone')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "tel",
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.editingCustomer.phone) = $event)),
                    class: "bg-gray-50 border border-gray-200 rounded-md w-full px-3 py-2.5 text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]"
                  }, null, 512), [
                    [_vModelText, _ctx.editingCustomer.phone]
                  ])
                ]),
                _createElementVNode("div", _hoisted_131, [
                  _createElementVNode("label", _hoisted_132, _toDisplayString(_ctx.directT('crm.customers.address')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.editingCustomer.address) = $event)),
                    class: "bg-gray-50 border border-gray-200 rounded-md w-full px-3 py-2.5 text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]"
                  }, null, 512), [
                    [_vModelText, _ctx.editingCustomer.address]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_133, _toDisplayString(_ctx.directT('crm.customers.city')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.editingCustomer.city) = $event)),
                    class: "bg-gray-50 border border-gray-200 rounded-md w-full px-3 py-2.5 text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]"
                  }, null, 512), [
                    [_vModelText, _ctx.editingCustomer.city]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_134, _toDisplayString(_ctx.directT('crm.customers.state')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.editingCustomer.state) = $event)),
                    class: "bg-gray-50 border border-gray-200 rounded-md w-full px-3 py-2.5 text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]"
                  }, null, 512), [
                    [_vModelText, _ctx.editingCustomer.state]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_135, _toDisplayString(_ctx.directT('crm.customers.country')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.editingCustomer.country) = $event)),
                    class: "bg-gray-50 border border-gray-200 rounded-md w-full px-3 py-2.5 text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]"
                  }, null, 512), [
                    [_vModelText, _ctx.editingCustomer.country]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_136, _toDisplayString(_ctx.directT('crm.customers.receivedAmount')), 1),
                  _createElementVNode("div", _hoisted_137, [
                    _cache[55] || (_cache[55] = _createElementVNode("span", { class: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" }, "₪", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      min: "0",
                      step: "0.01",
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.editingCustomer.received) = $event)),
                      placeholder: "0.00",
                      class: "bg-gray-50 border border-gray-200 rounded-md w-full pl-8 pr-3 py-2.5 text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]"
                    }, null, 512), [
                      [_vModelText, _ctx.editingCustomer.received]
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_138, _toDisplayString(_ctx.directT('crm.customers.status')), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.editingCustomer.status) = $event)),
                    required: "",
                    class: "bg-gray-50 border border-gray-200 rounded-md w-full px-3 py-2.5 text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusOptions, (status) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: status,
                        value: status
                      }, _toDisplayString(status === 'All' ? _ctx.directT('crm.customers.all') : 
                   status === 'New' ? _ctx.directT('crm.customers.new') : 
                   status === 'Active' ? _ctx.directT('crm.customers.active') : 
                   status === 'Inactive' ? _ctx.directT('crm.customers.inactive') : status), 9, _hoisted_139))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.editingCustomer.status]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_140, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args))),
                  class: "w-full sm:w-auto px-4 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-md transition-all dark:bg-[#172036] dark:text-gray-200 dark:hover:bg-[#1e2746] order-2 sm:order-1"
                }, _toDisplayString(_ctx.directT('crm.customers.cancel')), 1),
                _createElementVNode("button", {
                  type: "submit",
                  class: "w-full sm:w-auto px-4 py-2.5 bg-primary-500 hover:bg-primary-600 text-white rounded-md transition-all order-1 sm:order-2 mb-2 sm:mb-0",
                  disabled: _ctx.saving
                }, _toDisplayString(_ctx.saving ? _ctx.directT('crm.customers.saving') : _ctx.directT('crm.customers.saveChanges')), 9, _hoisted_141)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}